import { ReactNode } from 'react';
import { Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import OutlinedCard01 from '../forms/OutlinedCard01';

interface ILayoutBaseDePaginaProps {
    mostraCardTotal?: boolean;
    mostraCardSelecionado?: boolean;
    titulo: string;
    labelSelecionado: string;
    labeltotal: string;
    selecionado: string;
    total: string;
    children: React.ReactNode
    barraDeFerramentas?: ReactNode;
}
export const LayoutBaseDeFinanceiro: React.FC<ILayoutBaseDePaginaProps> = ({ 
  children, 
  titulo, 
  selecionado,
  total, 
  labelSelecionado,  
  labeltotal,  
  mostraCardTotal = true,
  mostraCardSelecionado = true,
  barraDeFerramentas,
}) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const theme = useTheme();
  return (
    <Box  height="100%" display="flex" flexDirection="column" >
      <Box
        padding={1}
        marginLeft={smDown ? 1 : 2}
        display="flex"
        flexDirection={smDown ? 'column' : 'row'}
        alignItems={smDown ? 'stretch' : 'center'}
        gap={1}
        flexShrink={0}
        minHeight={theme.spacing(smDown ? 6 : mdDown ? 8 : 12)}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            variant={smDown ? 'h5' : mdDown ? 'h4' : 'h3'}
            sx={smDown ? { fontWeight: 800, fontSize: '1.6rem', letterSpacing: '-0.02em' } : undefined}
          >
            {titulo}
          </Typography>
        </Box>
        <Box
          flex={1}
          display="flex"
          flexWrap="wrap"
          padding={smDown ? 0 : 1}
          justifyContent={smDown ? 'flex-start' : 'end'}
        >
          {mostraCardTotal && (
            <OutlinedCard01
              cor='#4D8FDB'
              nome={labeltotal}
              valor={total}
            />
          )}
          {mostraCardSelecionado && (
            <OutlinedCard01
              cor='#23DEA1'
              nome={labelSelecionado}
              valor={selecionado}
            />
          )}
        </Box>
      </Box>
      {barraDeFerramentas && (
        <Box flexShrink={0}>
          {barraDeFerramentas}
        </Box>
      )}
      <Box padding={1} flex={1} minHeight={0} overflow="auto">
        {children}
      </Box>
    </Box>
  );
};